module.exports = __webpack_public_path__ + "img/logo-siakang.8ea21cb2.png";